import React, { useEffect, useState } from "react";
import { postRequest } from "../../api/ApiInstance";

const Contact = () => {

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [mobile, setMobile] = useState('')
  const [subject, setSubject] = useState('')
  const [desc, setDesc] = useState('')

  // const a = process.env.REACT_BACKEND_URL

  // console.log(process?.env)

  // console.log('safsfsd', a)


  // const handleSubmit = async (e) => {

  //   e.preventDefault();

  //   const data = await postRequest('/contactus', {
  //     full_name :name, 
  //     email,
  //     mobile,
  //     subject,
  //     // description: desc
  //     message: desc 
  //   })

  //   console.log(data)
  //   setName('');
  // setEmail('');
  // setMobile('');
  // setSubject('');
  // setDesc('');


  // }
const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const data = await postRequest('/contactus', {
      full_name: name,
      email,
      mobile,
      subject,
      message: desc
    });

    console.log(data);

    // form clear
    setName('');
    setEmail('');
    setMobile('');
    setSubject('');
    setDesc('');

    // page refresh AFTER successful submit
    window.location.reload();

  } catch (error) {
    console.error(error?.response?.data || error.message);
  }
};


  return (
    <div>

      {/* Hero Section */}
      <div className="relative h-[340px] w-full">
        <img
          src="https://media.gettyimages.com/id/541903912/video/4k-red-streaks-light-animation-background-seamless-loop.jpg?s=640x640&k=20&c=kCVmgkIPd6KHWRuIrOUbXyF38j8lHwumkQXjmCkodhQ="
          alt="contact"
          className="w-full h-full object-containt"
        />
        <div className="absolute inset-0 bg-black/70 flex flex-col items-center justify-center text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl font-bold">
            Contact Us
          </h1>
          <p className="mt-4 max-w-xl text-gray-300 text-sm">
            News tips, feedback & advertising.
          </p>
        </div>

      </div>

      {/* Content */}
      {/* <div className="max-w-7xl mx-auto px-4 py-20 grid grid-cols-1 lg:grid-cols-2 gap-20"> */}
      <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-1 lg:grid-cols-2 gap-20">

        {/* Form Card */}
        <div className="bg-white rounded-2xl shadow-xl p-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Get in touch
          </h2>
          <p className="text-gray-500 text-sm mb-8">
            We usually respond within 24 hours.
          </p>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <input
                type="text"
                placeholder="Full Name"
                className="border rounded-xl p-4 outline-none focus:ring-2 focus:ring-red-500"
                onChange={(e) => setName(e?.target?.value)}
              />
              <input
                type="email"
                placeholder="Email Address"
                className="border rounded-xl p-4 outline-none focus:ring-2 focus:ring-red-500"
                onChange={(e) => setEmail(e?.target?.value)}
              />
            </div>

            <input
              type="text"
              placeholder="Mobile Number"
              className="w-full border rounded-xl p-4 outline-none focus:ring-2 focus:ring-red-500"
              onChange={(e) => setMobile(e?.target?.value)}
            />

            <select className="w-full border rounded-xl p-4 outline-none focus:ring-2 focus:ring-red-500" onChange={(e) => setSubject(e?.target?.value)}>
              <option>News Tip</option>
              <option>Correction / Complaint</option>
              <option>Advertisement</option>
              <option>Career / Internship</option>
              <option>General Feedback</option>
            </select>

            <textarea
              rows="4"
              placeholder="Write your message..."
              className="w-full border rounded-xl p-4 outline-none focus:ring-2 focus:ring-red-500"
              onChange={(e) => setDesc(e?.target?.value)}
            ></textarea>

            {/* <button type="submit" className="w-full bg-red-600 text-white py-4 rounded-xl font-semibold hover:bg-black transition" onClick={(e)=> handleSubmit(e)}>
              Send Message
            </button> */}
            <button
              type="submit"
              className="w-full bg-red-600 text-white py-4 rounded-xl font-semibold hover:bg-black transition"
            >
              Send Message
            </button>
          </form>
        </div>
        {/* Info Section */}
        <div className="space-y-8">
          {/* Office Location */}
          {/* <a
            href="https://www.google.com/maps?q=jabalpur%20Madhya%20Pradesh"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-start gap-4 p-2 hover:bg-gray-50 rounded-lg transition"
          >
            <i className="fa-solid fa-location-dot text-red-600 text-2xl mt-1"></i>
            <div>
              <h4 className="font-semibold text-gray-900 group-hover:text-red-600 transition">
                Office Location
              </h4>
              <p className="text-gray-600 text-sm">
                Bundeli Chugli & Hindi Chugli <br />
                Jabalpur, Madhya Pradesh, India
              </p>
            </div>
          </a> */}
          <a
            href="https://www.bing.com/maps?q=Bundeli+chugli+office+Govind+City+Mahoba+By+pass+Road+471001"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-start gap-4 p-2 hover:bg-gray-50 rounded-lg transition"
          >
            <i className="fa-solid fa-location-dot text-red-600 text-xl mt-1"></i>
            <div>
              <h4 className="font-semibold text-gray-900 group-hover:text-red-600 transition">
                Office Location
              </h4>
              <p className="text-gray-600 text-sm">
                Bundeli Chugli Office <br />
                Govind City, Near Bagrajan Mata Mandir <br />
                Mahoba By Pass Road, 471001 <br />
                Chhatarpur, Madhya Pradesh <br />
                <a
                  href="tel:+919926903939"
                  className="flex items-center gap-2 text-red-600 hover:underline mt-1"
                >
                  <i className="fa-solid fa-phone"></i>
                  +91 99269 03939
                </a>
              </p>
            </div>
          </a>
          {/* Editorial Desk */}
          <a
            href="mailto:bundelichugli@gmail.com"
            className="group flex items-start gap-4 p-2 hover:bg-gray-50 rounded-lg transition"
          >
            <i className="fa-solid fa-envelope-open-text text-red-600 text-xl mt-1"></i>
            <div>
              <h4 className="font-semibold text-gray-900 group-hover:text-red-600 transition">
                Editorial Desk
              </h4>
              <p className="text-gray-600 text-sm">
                <a
                  href="mailto:bundelichugli@gmail.com"
                  className="flex items-center gap-2 text-red-600 hover:underline"
                >
                  <i className="fa-solid fa-envelope"></i>
                  bundelichugli@gmail.com
                </a>

                <a
                  href="tel:+919926903939"
                  className="flex items-center gap-2 text-red-600 hover:underline mt-1"
                >
                  <i className="fa-solid fa-phone"></i>
                  +91 99269 03939
                </a>

                <span className="block mt-1">
                  Mon – Sat | 9 AM – 8 PM
                </span>
              </p>
            </div>
          </a>
          {/* Advertisement */}
          <a
            href="mailto:bundelichugli@gmail.com"
            className="group flex items-start gap-4 p-2 hover:bg-gray-50 rounded-lg transition"
          >
            <i className="fa-solid fa-bullhorn text-red-600 text-xl mt-1"></i>
            <div>
              <h4 className="font-semibold text-gray-900 group-hover:text-red-600 transition">
                Advertise With Us
              </h4>
              <p className="text-gray-600 text-sm">
                <a
                  href="mailto:bundelichugli@gmail.com"
                  className="flex items-center gap-2 text-red-600 hover:underline"
                >
                  <i className="fa-solid fa-envelope"></i>
                  bundelichugli@gmail.com
                </a>
                <br />
                Brand Promotions & Media Planning
              </p>
            </div>
          </a>
        </div>
      </div>
      {/* Map */}
      <div className="w-full h-[380px]">
<iframe
  title="Office Location Map"
  className="w-full h-full"
  src="https://www.google.com/maps?q=24.932909,79.6006851&z=16&output=embed"
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
></iframe>

      </div>
    </div>
  );
};

export default Contact;
